module.exports = __webpack_public_path__ + "img/icon_line_tab2.d9bdc710.png";